import { render, staticRenderFns } from "./cadtemplatesmensagens.vue?vue&type=template&id=68def489&"
import script from "./cadtemplatesmensagens.vue?vue&type=script&lang=js&"
export * from "./cadtemplatesmensagens.vue?vue&type=script&lang=js&"
import style0 from "./cadtemplatesmensagens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports